import { create } from 'zustand';

interface DrawTableStore {
    toggleArray: boolean[];
    set_toggleArray: (arr: boolean[]) => void;
}

export const useDrawTableStore = create<DrawTableStore>((set) => ({
    toggleArray: [],
    set_toggleArray: (arr) => set({ toggleArray: arr }),
}));
